module.exports = __webpack_public_path__ + "20251203d193705t/img/newhands-icon.2d9c01eb.png";